<template>
  <div>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Training</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Quiz</li>
        </ol>
      </nav>


			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">
                <div class="row mb-4">
                  <!-- calculation of score placeholder -->
                  <div class="text-center" v-if="calculating">
                    <h2>Calculating Score! Please Wait...</h2>
                    <img src="@/assets/img/loading.svg">
                  </div>

                  <div class="text-center p-5" v-if="totalQuestions == 0 && questionsReady">
                    <h2>No quiz prepared. Please contact administration!</h2>
                    <button class="btn btn-info" style="color:white;" @click="redirectBack">Back</button>
                  </div>

                     <!-- Question Container-->
                     <div v-if="questionIndex < totalQuestions" v-bind:key="questionIndex">
                        <div>
                          <div class="col-xs-12 col-sm-6 col-md-12 col-md-12">
                            <progress-circle
                              class="mx-auto"
                              :diameter="175"
                              :completed-steps="Math.round((questionIndex / totalQuestions) * 100)"
                              circle-color="#DDDDDD"
                              start-color="#288FEB"
                              stop-color="#288FEB"
                              :circle-width="15"
                              :total-steps="100"
                            >
                              <p style="font-size: 25px; font-weight: 500; margin: 0;">
                                {{ Math.round((questionIndex / totalQuestions) * 100) }}%
                              </p>
                            </progress-circle>
                            <h3 class="text-center text-default mt-5 mb-5 px-5" style="width: 100%">
                              {{ question.text }}
                            </h3>
                          </div>

                          <div
                            class="option mb-3"
                            v-for="(response, index) in question.responses"
                            :class="{
                              'highlight-green': isCorrect[index] === 'correct',
                              'highlight-red': isCorrect[index] === 'wrong',
                              'highlight-default': index === selected && isCorrect[index] !== 'correct' && isCorrect[index] !== 'wrong',
                            }"
                            @click="!submitted && selectOption(index)"
                            :key="index + 1"
                          >
                            {{ charIndex(index + 1) }}. {{ response }}
                          </div>

                          <div class="cols-xs-12 col-sm-12 col-md-12 col-lg-12 p-5">
                            <div class="text-center">
                              <button
                                class="btn btn-info submitButton"
                                style="color: white;"
                                v-on:click="submitAnswer(question.id)"
                                :loading="isSubmitting"
                                :disabled="buttonNext || submitted"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                          v-if="resultsReady"
                          v-bind:key="questionIndex"
                          class="quizCompleted text-centered"
                        >
                          <!-- Failed Training Message-->
                          <div v-if="percent < 75">
                              <h5>Please re-watch the video and attempt the quiz again.</h5>
                              <br>
                              <br>
                              <h5>You have completed <strong>{{trainingVideo.training_video.name}} </strong> with a score of <strong style="color: red;">{{percent}}%</strong>.
                                  <br>A minimum score of <strong style="color: green;">75%</strong> is needed to pass this training.
                                  </h5>
                                  <br>
                                  <br>
                              <div>
                                <div>
                                  <div v-if="hasAttestationPolicy">
                                    <h5>Policies and Procedures related to this training video are available at the following link/s. Please read these carefully and click Attest to confirm that you have read and agree to adhere to the Policy.<br>
                                      <div v-for="(item, index) in policies" :key="index">
                                        <a href="#" @click="handleLinkClick(item)">{{ truncatedLink(item.name) }}</a><br>
                                      </div>
                                    </h5>
                                    <div class="mt-5">
                                        <router-link :to="'/training/assigned-training'" class="btn btn-outline-warning">Back to training video</router-link>
                                        <button class="btn btn-primary ms-3" style="text-transform: capitalize;" :disabled="!linkClicked" type="button" @click="confirmAttest">
                                            Attest to Policy
                                        </button>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="trainingVideo.training_video.takeaway != ''">
                                  <h5><br/>Need a reminder of what we have covered in this topic? Access key takeaways from this training video
                                      <a @click="pushTrainingLink(trainingVideo.training_video.takeaway)" class="href" style="color:#00a0c1; cursor: pointer;">here</a>.
                                  </h5>
                                </div>
                              </div>
                          </div>
                          <!-- Passed Training Message-->
                          <div v-if="percent >= 75">

                              <h5>Congratulations! You have successfully completed <strong>{{trainingVideo.training_video.name}} </strong>
                                  with a score of <strong>{{percent}}%. </strong></h5>
                                  <br>
                                  <br>
                              <div>
                                <div v-if="hasAttestationPolicy">
                                    <h5>Policies and Procedures related to this training video are available at the following link/s. Please read these carefully and click Attest to confirm that you have read and agree to adhere to the Policy.<br>
                                      <div v-for="(item, index) in policies" :key="index">
                                        <a href="#" @click="handleLinkClick(item)">{{ truncatedLink(item.name) }}</a><br>
                                      </div>
                                    </h5>
                                    <div class="mt-5">
                                        <router-link :to="'/training/assigned-training'" class="btn btn-outline-warning">Back to training video</router-link>
                                        <button class="btn btn-primary ms-3" style="text-transform: capitalize;" :disabled="!linkClicked" type="button" @click="confirmAttest">
                                            Attest to Policy
                                        </button>
                                    </div>
                                </div>
                                <div v-if="trainingVideo.training_video.takeaway != ''">
                                    <h5><br/>Need a reminder of what we have covered in this topic? Access key takeaways from this training video
                                        <a @click="pushTrainingLink(trainingVideo.training_video.takeaway)" class="href" style="color:#00a0c1; cursor: pointer;">here</a>.
                                    </h5>
                                </div>
                              </div>
                            </div>
                      </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { ProgressCircle } from 'vue-progress-circle'
import "vue3-circle-progress/dist/circle-progress.css";

export default {
  name: "ScheduledJobs",

  components: {
    ProgressCircle
  },

  data() {
    return {
      question: {},
      totalQuestions: null,
      userQuizResults: [],
      latestQuizAttempt: [],
      trainingVideo: {},
      organisation: {},

      quizStarted: false,
      questionsReady: false,
      isPassed: false,
      resultsReady: false,
      buttonNext: true,
      isSubmitting: false,
      isCorrect: [false, false, false, false],

      questionIndex: 0,
      percent: 0,
      selected: -1,
      correctAnswer: 0,
      selectedAnswer: 0,
      refresh: 0,
      answerLogs: [],
      correctAnswers: 0,
      calculating: false,
      submitted: false,
      hasAttestationPolicy: false,

      linkClicked: false,
      linkClickedCount: 0,
      totalLinks: 0,
      linkClickeds: [],
      attested: false,
      organisationID: this.$helper.setOrganisationID()
    };
  },

  async mounted() {
    if (this.$helper.isVertexAnalyst()) {
      let analystOrg = null;
      try {
        const organisationString = localStorage.getItem('userOrganisation');
        analystOrg = organisationString ? JSON.parse(organisationString) : null;
      } catch (e) {
        analystOrg = null;
      }
      this.organisationID = analystOrg?.id || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id || this.organisationID;
    }

    // 🚨 Changed order: Wait for video details FIRST so policies and headers load correctly
    await this.getTrainingVideo();

    // Now safe to proceed
    await this.getTotalQuestions();
    await this.getQuestion();
    this.hasUserWatchedVideo();
  },

  methods: {
    getQuestion() {
      // 🚨 FIX: Use $route.params.id instead of relying on this.trainingVideo
      let route = this.$route.query.is_module === 'true'
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/modules/${this.$route.params.id}/assignments/${this.$route.query.assigned}/questions`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${this.$route.params.id}/assigned/${this.$route.query.assigned}/questions`;

      this.$axios.get(route).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.question = {
              id: data.ID,
              text: data.question,
              responses: [data.option_1, data.option_2, data.option_3, data.option_4],
          };
          this.questionsReady = true;
        } else { this.$toast.error(response.data.message); }
      }).catch();
    },

    async getTotalQuestions() {
      // 🚨 FIX: Use $route.params.id instead of relying on this.trainingVideo
      let route = this.$route.query.is_module === 'true'
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/assignments/${this.$route.query.assigned}/modules/${this.$route.params.id}/questions/total`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/assigned/${this.$route.query.assigned}/questions/${this.$route.params.id}/total`;

      return new Promise((resolve, reject) => {
          this.$axios.get(route)
          .then(response => { this.totalQuestions = response.data.total; resolve(); })
          .catch(error => reject(error));
      });
    },

    async getLatestQuizAttempt() {
      let route = this.$route.query.is_module === 'true'
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/modules/${this.$route.params.id}/answers/${this.$route.query.assigned}`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${this.$route.params.id}/answers/${this.$route.query.assigned}`;

      return new Promise((resolve, reject) => {
          this.$axios.get(route)
          .then(response => { this.latestQuizAttempt = response.data.quiz_result; resolve(response.data.quiz_result); })
          .catch(error => reject(error));
      });
    },

    async getAnswerLogsByAttemptID(attemptID) {
      let assignmentTarget = this.$route.query.is_module === 'true' ? this.$route.query.assigned : (this.latestQuizAttempt.assigned_user_video_id || this.latestQuizAttempt.AssignedUserVideoID);

      let route = this.$route.query.is_module === 'true'
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/answer-logs/${attemptID}/assignments/${assignmentTarget}`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/answer-logs/${attemptID}/assigned-videos/${assignmentTarget}`;

      const data = await this.$axios.get(route).then((response) => {
          if (response.data.success) { this.answerLogs = response.data.user_answer_logs; return response.data.user_answer_logs; }
          else { return null; }
      }).catch((error) => { return error; });

      return data;
    },

    async checkAnswer(questionID, answer, attemptID) {
        let data = { answer: answer };

        if (this.$route.query.is_module === 'true') {
          data.user_assignment_id = parseInt(this.$route.query.assigned);
        } else {
          data.assigned_user_video_id = this.latestQuizAttempt.assigned_user_video_id || this.latestQuizAttempt.AssignedUserVideoID;
        }

        let route = this.$route.query.is_module === 'true'
          ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/modules/${this.$route.params.id}/attempt/${attemptID}/questions/${questionID}/check-answer`
          : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/videos/${this.$route.params.id}/attempt/${attemptID}/questions/${questionID}/check-answer`;

        const result = await this.$axios.post(route, data).then((response) => { return response; }).catch();
        return result;
    },

    getTrainingPolicies() {
      // 🚨 Bypass policy checks entirely for custom modules for now since they are tied to legacy videos
      if (this.$route.query.is_module === 'true') return Promise.resolve([]);

      const userID = this.$store.state.auth.jwtPayload.user_id;
      const trainingVideoID = this.latestQuizAttempt.training_video_id;
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return this.$axios.get(`/trainings/organisations/${this.organisationID}/users/${userID}/video/${trainingVideoID}/training-policy?timezone${userTimeZone}`)
        .then((response) => {
          if (response.data.success) {
            const filteredPolicies = response.data.training_policies.filter(policy => !policy.attested || !policy.attested.attested);
            return filteredPolicies;
          } else {
            this.$toast.error(response.data.message);
            return null;
          }
        })
        .catch((error) => {
          console.error('An error occurred while fetching data:', error);
          return null;
        });
    },

    handleLinkClick(item) {
      if (!item.link.includes("http")) {
        this.openLinkInNewTab("https://" + item.link);
      } else {
        this.openLinkInNewTab(item.link);
      }

      if (!this.linkClickeds.includes(item.ID)) {
        this.linkClickedCount++;
        this.linkClickeds.push(item.ID);
      }

      if (this.linkClickedCount === this.totalLinks) {
        this.linkClicked = true;
      }
    },

    openLinkInNewTab(link) {
      window.open(link, '_blank');
    },

    truncatedLink(link) {
      const maxLength = 50;
      let truncated = link.substring(0, maxLength);
      if (link.length > maxLength) {
        truncated += '...';
      }
      return truncated;
    },

    getOrganisationFeatures() {
      return this.$axios.get('/organisation-feature/user/'+ this.$store.state.auth.jwtPayload.user_id+'/organisations/'+this.organisationID)
      .then((response) => {
          if (response.data.success){
              return response.data.org_features
          } else {
            this.$toast.error(response.data.message)
            return null
          }
      })
      .catch()
    },

    updateQuizStarted() {
      this.latestQuizAttempt.quiz_started = moment().utc()

      let route = this.$route.query.is_module === 'true'
        ? `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/answers/${this.latestQuizAttempt.ID}?type=quiz_started&is_module=true`
        : `/trainings/users/${this.$store.state.auth.jwtPayload.user_id}/answers/${this.latestQuizAttempt.ID}?type=quiz_started`;

      this.$axios.put(route, {})
    },

    async getTrainingVideo(){
      if (this.$route.query.is_module === 'true') {
        try {
            const userID = this.$store.state.auth.jwtPayload.user_id;
            const response = await this.$axios.get(`/trainings/users/${userID}/assignments/${this.$route.query.assigned}`);

            if (response.data.success && response.data.user_assignment) {
                const mod = response.data.user_assignment.training_module || response.data.user_assignment.TrainingModule || {};
                this.trainingVideo = {
                    training_video: {
                        name: mod.name || mod.Name || 'Training Module',
                        takeaway: ""
                    }
                };
            } else {
                this.trainingVideo = { training_video: { name: 'Training Module', takeaway: '' } };
            }
        } catch (e) {
            this.trainingVideo = { training_video: { name: 'Training Module', takeaway: '' } };
        }
      } else {
        await this.$axios.get('/trainings/organisations/' + this.organisationID +'/videos/' + this.$route.params.id)
        .then((response) => {
            if (response.data.success){
                this.trainingVideo = response.data.assigned_org_video;
            } else {
                this.$toast.error(response.data.message)
            }
        })
        .catch()
      }
    },

    selectOption(index) {
      if (!this.submitted) {
        this.buttonNext = false;
        this.selectedAnswer = index + 1;
        this.selected = index;
      }
    },

    async submitAnswer(questionID) {
      this.buttonNext = true;
      this.submitted = true;

      if (this.latestQuizAttempt.quiz_started == null && !this.$store.state.auth.isSuperAdmin) {
        this.updateQuizStarted();
      }

      this.isCorrect = new Array(this.question.responses.length);

      const answerData = await this.checkAnswer(questionID, this.selectedAnswer, this.latestQuizAttempt.attempt_id);

      if (answerData.data.success == false) {
        this.$toast.error(answerData.data.message);
        return;
      }

      if (answerData.data.isCorrect) {
        this.isCorrect[this.selected] = 'correct';
        this.correctAnswers += 1;
      } else {
        this.isCorrect[this.selected] = 'wrong';
      }

      this.refresh = Math.random();

      setTimeout(() => {
        this.isCorrect = new Array(this.question.responses.length);
        this.selected = -1;
        this.submitted = false;

        if (answerData.data.last)
          this.getScore();

        if (this.questionIndex + 1 < this.totalQuestions)
          this.getQuestion();

        if (this.questionIndex < this.totalQuestions)
          this.questionIndex++;
      }, 3000);
    },

    async getScore() {
      this.calculating = true;

      var quiz = await this.getLatestQuizAttempt()
      this.percent = quiz.grade
      this.isPassed = quiz.is_passed
      this.calculating = false;
      this.resultsReady = true;

      this.policies = await this.getTrainingPolicies()

      this.hasAttestationPolicy = this.policies.length > 0
      this.totalLinks = this.policies.length

      if (!this.hasAttestationPolicy) {
        var timer = 5000;

      if (this.trainingVideo.training_video.takeaway != "") {
        timer = 15000
      }

        this.timeOut = setTimeout(() => {
          this.$router.push('/training/assigned-training')
          return
        }, timer);
      }
    },

    redirectBack(){
      this.$router.back()
    },

    pushTrainingLink(link) {
        if (!link.includes("http")) {
            let newLink = "https://" + link
            window.open(newLink, '_blank');
        }
        window.open(link, '_blank');
    },

    handleAttestationClick(link) {
      if (!link.includes("http")) {
            let newLink = "https://" + link
            window.open(newLink, '_blank');
        }
        window.open(link, '_blank');

      this.hasAttested = true;
    },

    extractFilenameFromGCSUrl(url) {
        const gcsBaseUrl = 'https://storage.googleapis.com/';
        if (url.startsWith(gcsBaseUrl)) {
          const path = url.slice(gcsBaseUrl.length);
          const pathParts = path.split('/');
          const filename = pathParts.pop().split('?')[0];
          return filename || url;
        } else {
          return url;
        }
    },

    async confirmAttest() {
      if (this.attested)
        return

      this.attested = true;

      try {
        for (const element of this.policies) {
          const data = {
            training_video_id: element.training_videos[0].ID,
            link: this.extractFilenameFromGCSUrl(element.link),
            date_attested: moment().utc(),
            attested: true,
            training_policy_id: element.ID,
            version: element.version
          };

          const response = await this.$axios.post("/trainings/users/" + this.$store.state.auth.jwtPayload.user_id + "/attest-policy", data);

          if (!response.data.success)
            this.$toast.error(response.data.message);
        }

        this.$toast.success("Successfully attested policy.");
      } catch (error) {
        console.error("Error:", error);
      }
    },

    getAttestationStatus(item) {
      let hasPolicy = false;

      for (let i = 0; i < item.length; i++) {
          const policy = item[i];
          if (policy.attested && !policy.attested.attested) {
              hasPolicy = true;
          }
      }
      return hasPolicy;
    },

    async hasUserWatchedVideo() {
        if (!this.$store.state.auth.isSuperAdmin) {
          await this.getLatestQuizAttempt();

          if (this.latestQuizAttempt == null || this.latestQuizAttempt.length == 0) {
            this.$router.push('/training/assigned-training');
          }

          if (this.latestQuizAttempt.video_finished == null || this.latestQuizAttempt.quiz_finished != null) {
            this.$router.push('/training/assigned-training');
          }

          if (this.latestQuizAttempt.video_finished != null && this.latestQuizAttempt.quiz_started != null) {
            const data = await this.getAnswerLogsByAttemptID(this.latestQuizAttempt.attempt_id)
            this.questionIndex = data.length
          }
        }
    },

    charIndex(i) {
      let char = 'A'
      switch (i) {
        case 2: char = 'B'; break;
        case 3: char = 'C'; break;
        case 4: char = 'D'; break;
      }
      return char
    },
  },

  beforeRouteLeave () {
    clearTimeout(this.timeOut);
  },

  computed: {
    highlight() {
    return this.highlight;
    }
  },

}
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 20px;
          border-radius: 20px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
  font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
  font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
  font-size: 14px!important;
}

.icon {
    color: #ff5252;
    font-size: 10rem;
}
.is-active {
    color: #00e676;
}

.optionContainer {
    margin-top: 12px;
    flex-grow: 1;
}

.option {
    /* border-radius: 290486px; */
    padding: 9px 18px;
    margin: auto;
    margin-bottom: 12px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.85);
    border: transparent 1px solid;
    width: 80%;
    overflow-wrap: break-word;
    transition: 0.3s;
}

.option{
    border: solid #687784 .5px;
    border-radius: 8px;
}

.option.highlight-default {
    color: white;
    background-color: #00a0c1;
}

.option.highlight-red {
    color: white;
    background-color: #F44336;
}

.option.highlight-green {
    color: white;
    background-color: #4CAF50;
}

.option:hover {
    background-color: #01b7db;
    color: white;
}

.option:active {
    transform: scaleX(0.99);
}

.submitButton {
    color: #00a0c1;
}

.current-counter{
  font-size: 40px;
}
.current-counter::after {
  content: "%";
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
	color: white;
	pointer-events: none;
	background-color: #435666;
	border-color: #435666;
	opacity: .5;
}
</style>